import {
  ActivityLogApi,
  AmazonAccountsApi,
  AmazonListingsApi,
  ConfigApi,
  CustomPropertyPrefix,
  EbayApi,
  EbayProductsApi,
  ListingsApi,
  MetadataApi,
  ProductsApi,
  UserApi,
  AttributesApi,
} from './api';
import * as _ from 'lodash';
export const amazonListingsApi = new AmazonListingsApi({basePath: '/'});
export const amazonAccountsApi = new AmazonAccountsApi({basePath: '/'});
export const configApi = new ConfigApi({basePath: '/'});
configApi.getConfig = _.memoize(configApi.getConfig);
export const activityLogApi = new ActivityLogApi({basePath: '/'});
export const productApi = new ProductsApi({basePath: '/'});
export const listingsApi = new ListingsApi({basePath: '/'});
export const ebayApi = new EbayApi({basePath: '/'});
export const ebayProductsApi = new EbayProductsApi({basePath: '/'});
export const metaDataApi = new MetadataApi({basePath: '/'});
export const userApi = new UserApi({basePath: '/'});
export const attributesApi = new AttributesApi({basePath: '/'});

export function isCustomProperty(key) {
  return _.some(CustomPropertyPrefix, prefix => key.startsWith(prefix as any));
}

export * from './api';
